module.exports = __webpack_public_path__ + "static/media/1.d41031f2.png";